module.exports = __webpack_public_path__ + "img/halloween-bg.fd6ec691.jpg";